"use client";
import * as React from "react";
const SvgLocationRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.1 0A6.47 6.47 0 0 0 .6 6.67q0 3.87 5.96 9.13a.83.83 0 0 0 1.08 0q5.96-5.26 5.96-9.13A6.47 6.47 0 0 0 7.1 0m0 8.13A1.63 1.63 0 0 1 5.48 6.5 1.63 1.63 0 0 1 7.1 4.89 1.63 1.63 0 0 1 8.73 6.5 1.63 1.63 0 0 1 7.1 8.13" }));
export {
  SvgLocationRound as default
};
